"use client";
import type {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from "react";
import { cn } from "@repo/shared/utils";
import { type VariantProps, cva } from "class-variance-authority";

const headerVariants = cva(
  "w-full p-4 flex flex-row items-center z-50 shadow-lg",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground",
        secondary: "bg-secondary text-secondary-foreground",
        tertiary: "bg-tertiary text-tertiary-foreground",
        accent: "bg-accent text-black font-bold",
        ghost: "text-black bg-white",
      },
      position: {
        sticky: "fixed top-0 left-0",
        floating: "",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
);

export interface HeaderProps
  extends PropsWithChildren,
    VariantProps<typeof headerVariants>,
    DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {}

export const Header = ({
  children,
  variant,
  position,
  className,
  ...props
}: HeaderProps) => {
  return (
    <header
      className={cn(headerVariants({ variant, position, className }))}
      {...props}
    >
      {children}
    </header>
  );
};
